import { Box, HStack, useRecipe } from '@chakra-ui/react';
import React from 'react';

import { route } from 'nextjs-routes';

import config from 'configs/app';
import useApiQuery from 'lib/api/useApiQuery';
import useIsMobile from 'lib/hooks/useIsMobile';
import { TX } from 'stubs/tx';
import { Heading } from 'toolkit/chakra/heading';
import { TableTopBorder } from 'toolkit/chakra/table';
import AdaptiveTabs from 'toolkit/components/AdaptiveTabs/AdaptiveTabs';
import { recipe as cardRecipe } from 'toolkit/theme/recipes/card.recipe';
import LatestOptimisticDeposits from 'ui/home/latestDeposits/LatestOptimisticDeposits';
import LatestTxs from 'ui/home/LatestTxs';
import LatestWatchlistTxs from 'ui/home/LatestWatchlistTxs';
import SocketNewItemsNotice from 'ui/shared/SocketNewItemsNotice';
import useAuth from 'ui/snippets/auth/useIsAuth';
import useNewTxsSocket from 'ui/txs/socket/useTxsSocketTypeAll';

import LatestArbitrumDeposits from './latestDeposits/LatestArbitrumDeposits';

const rollupFeature = config.features.rollup;

const TransactionsHome = () => {
  const isAuth = useAuth();
  const recipe = useRecipe({ recipe: cardRecipe });

  const isMobile = useIsMobile();
  const txsCount = isMobile ? 2 : 6;

  const transactionsQuery = useApiQuery('general:homepage_txs', {
    queryOptions: {
      placeholderData: Array(txsCount).fill(TX),
    },
  });

  const { isPlaceholderData } = transactionsQuery;

  const txsUrl = route({ pathname: '/txs' });
  const { num, showErrorAlert } = useNewTxsSocket({ type: 'txs_home', isLoading: isPlaceholderData });

  if ((rollupFeature.isEnabled && (rollupFeature.type === 'optimistic' || rollupFeature.type === 'arbitrum')) || isAuth) {
    const tabs = [
      {
        id: 'txn',
        title: 'Latest txn',
        component: <LatestTxs txsUrl={ txsUrl } txsCount={ txsCount } { ...transactionsQuery }/> },
      rollupFeature.isEnabled && rollupFeature.type === 'optimistic' &&
        { id: 'deposits', title: 'Deposits (L1→L2 txn)', component: <LatestOptimisticDeposits/> },
      rollupFeature.isEnabled && rollupFeature.type === 'arbitrum' &&
        { id: 'deposits', title: 'Deposits (L1→L2 txn)', component: <LatestArbitrumDeposits/> },
      isAuth && { id: 'watchlist', title: 'Watch list', component: <LatestWatchlistTxs/> },
    ].filter(Boolean);
    return (
      <>
        <Heading level="2" mb={ 6 }>Transactions</Heading>
        <AdaptiveTabs tabs={ tabs } unmountOnExit={ false } listProps={{ mb: 3 }}/>
      </>
    );
  }

  return (
    <Box css={ recipe() } p={{ lg: 6, base: 4 }}>
      <HStack mb={ 4 } wrap="wrap" justifyContent="space-between">
        <Heading
          level="2"
        >
          Latest transactions
        </Heading>
        <SocketNewItemsNotice borderBottomRadius={ 0 } url={ txsUrl } num={ num } showErrorAlert={ showErrorAlert } isLoading={ isPlaceholderData }/>
      </HStack>
      <TableTopBorder mb={ 6 } ml={ 0 } w="full"/>
      <LatestTxs txsUrl={ txsUrl } txsCount={ txsCount } { ...transactionsQuery }/>
    </Box>
  );
};

export default TransactionsHome;
